import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createRepairProductEntry, createRepairProductOnEditEntry, getCustomerById, getRepairProductBySearch, getRepairReasonList } from '../services';
import notistack from 'modules/core/notistack';
import DataGrid, { Column, Paging, Scrolling, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import { useForm } from 'react-hook-form';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons';
import CustomerDataModal from './CustomerDataModal';
import SalesPersonModal from 'modules/transactions/estimate-payment-receipt/estimate-payment-receipt/components/SalesPersonModal';
import PaymentModal from 'modules/transactions/estimate-payment-receipt/estimate-payment-receipt/components/PaymentModal';
import { PaymentEntry } from 'modules/transactions/estimate-payment-receipt/estimate-payment-receipt/models/payment-form-model';
import { apiClient } from 'helpers/api_helper';
import { decryptItem } from 'helpers/secureNavigate';

type RepairReason = {
    reason: string;
    qty: number;
    amount: number;
    remark: string;
    leadTime: number;
    deliveryDate: string;
};


const RepairProductsDetails1 = () => {
    const { repairWorkItemId } = useParams();
    const [productData, setProduct] = useState<any[]>()
    const [customer, setCustomer] = useState<any[]>([]);
    const [repairReasonList, setRepairReasonList] = useState<any[]>([])
    const [data, setData] = useState<RepairReason[]>([]);
    const [editIndex, setEditIndex] = useState<number | null>(null);
    const [showCustomerModal, setShowCustomerModal] = useState(false)
    const [showSalesPersonModal, setShowSalesPersonModal] = useState(false);
    const [salesPersonId, setSalesPersonId] = useState<string | any>()
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [paymentData, setPaymentData] = useState<PaymentEntry[]>([]);
    const [editingPaymentData, setEditingPaymentData] = useState<PaymentEntry[]>([]);
    const [leadTime, setLeadTime] = useState<number | null>(null);
    const [deliveryDate, setDeliveryDate] = useState<string>("");
    const { register, handleSubmit, reset, setValue, watch } = useForm<RepairReason>();
    const [customerId, setCustomerId] = useState<string | number | null>(null);
    const [totalSGST, setTotalSGST] = useState(0);
    const [totalCGST, setTotalCGST] = useState(0);
    const [totalIGST, setTotalIGST] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);



    const getFutureDate = (days: number): string => {
        const date = new Date();
        date.setDate(date.getDate() + days);
        return date.toISOString().split("T")[0]; // yyyy-mm-dd
    };
    const handleReasonChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedText = e.target.value;
        const reasonObj = repairReasonList.find(r => r.text === selectedText);
        if (reasonObj) {
            const days = reasonObj.durationDays;
            const futureDate = getFutureDate(days);

            setLeadTime(days);
            setDeliveryDate(futureDate);

            // Update form values too
            setValue("leadTime", days);
            setValue("deliveryDate", futureDate);
        }
    };

    const onSubmit = (formData: RepairReason) => {
        if (editIndex !== null) {
            const updated = [...data];
            updated[editIndex] = formData;
            setData(updated);
            setEditIndex(null);
        } else {
            setData([...data, formData]);
        }
        reset()
    };

    const handleEdit = (rowData: RepairReason, index: number) => {
        setValue('reason', rowData.reason);
        setValue('qty', rowData.qty);
        setValue('amount', rowData.amount);
        setValue('remark', rowData.remark);
        setValue('leadTime', rowData.leadTime);
        setValue('deliveryDate', rowData.deliveryDate);
        setEditIndex(index);
    };

    const handleDelete = (index: number) => {
        const updated = data.filter((_, i) => i !== index);
        setData(updated);
    };

    useEffect(() => {
        getProductDetails();
        getCustomerDetails();
        getReasonListData();
        getCustomerCreditAmount()
    }, []);

    useEffect(() => {
        if (customerId) {
            getCustomerDetails();
            getCustomerCreditAmount();
        }
    }, [customerId]);

    // repairWorkItemId
    const getProductDetails = async () => {
        try {
            const response = await apiClient.get(`/api/v1/Repair/GetProductRepairWorkItemById?repairWorkItemId=${decryptItem(repairWorkItemId as string)}`);
            if (response.status == 200) {
                const responseData = response.data;

                setProduct([response.data.searchRepairProductDetails]);
                setCustomerId(responseData.customerId)
                setData(response.data.repairWorkDetailsList)

                setTotalSGST(responseData.sgstAmt || 0);
                setTotalCGST(responseData.cgstAmt || 0);
                setTotalIGST(responseData.igstAmt || 0);
                setTotalAmount(responseData.totalEstimateAmount || 0);
                setSalesPersonId(responseData.salesPersonId)
            }
            else {
                notistack.notifyFromApi(response)
            }
        } catch (error) {
            notistack.error('Failed to get repair product details')
            console.error("Failed to get product details", error);
        }
    };

    const [creditAmt, setCreditAmt] = useState(0)
    const getCustomerCreditAmount = async () => {
        try {
            // const response = await apiClient.get(`/api/v1/Store/GetCustomerSalesEntryDetails?CustomerId=${paymentData.}`)
            // if (response.status == 200) {
            //     // setCreditAmt(response.data)
            //     console.log(response)
            // }
        } catch (error) {

        }
    }


    const getCustomerDetails = async () => {
        try {
            const response = await getCustomerById(customerId!);
            if (response && response.data) {
                setCustomer(response.data ? [response.data] : []);
            }
            else {
                notistack.notifyFromApi(response)
            }
        } catch (error: any) {
            notistack.error(error.message)
            console.error("Failed to get customer details", error);
        }
    };

    const getReasonListData = async () => {
        try {
            const response = await getRepairReasonList()
            if (response.data) {
                setRepairReasonList(response.data)
            }
            else {
                notistack.notifyFromApi(response)
            }
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    const handleCustomerClickModal = () => {
        setShowCustomerModal(true);
    }

    const handleSalesPersonClick = () => {
        setShowSalesPersonModal(true);
    };

    const handleSalesPersonSelect = (salesPId: string) => {
        setSalesPersonId(salesPId)
    };

    const handlePaymentData = (data: PaymentEntry[]) => {
        setPaymentData(data);
    };
    const openEditPaymentModal = () => {
        setEditingPaymentData(paymentData);
        setShowPaymentModal(true);
    };

    const openAddPaymentModal = () => {
        setEditingPaymentData([]);
        setShowPaymentModal(true);
    };

    const { } = useMemo(() => {
        let totalSGST = 0;
        let totalCGST = 0;
        let totalAmount = 0;

        const gstCalculatedItems = data?.map((item: any) => {
            const baseAmount = parseFloat(item.amount) || 0;
            const sgst = +(baseAmount * 0.025).toFixed(2);
            const cgst = +(baseAmount * 0.025).toFixed(2);
            const itemTotal = +(baseAmount + sgst + cgst).toFixed(2);

            totalSGST += sgst;
            totalCGST += cgst;
            totalAmount += itemTotal;

            return {
                ...item,
                sgst,
                cgst,
                totalAmount: itemTotal
            };
        }) || [];

        return {
            gstCalculatedItems,
            totalSGST: +totalSGST.toFixed(2),
            totalCGST: +totalCGST.toFixed(2),
            totalAmount: +totalAmount.toFixed(2)
        };
    }, [data]);

    const handleCancel = () => {
        reset()
        navigate('/repair-product-list')
    }

    const navigate = useNavigate()

    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleSave = async () => {
        if (!salesPersonId) {
            notistack.error("Please select a Sales Person.");
            return;
        }

        const netWt = productData?.[0]?.netWt ?? 0;

        const repairWorkList = data.map((item) => {
            const matchedReason = repairReasonList.find(r => r.text === item.reason);
            return {
                RepairWorkId: matchedReason?.value ?? 0,
                QtyOrWt: parseFloat(item.qty?.toString()),
                RepairAmount: parseFloat(item.amount?.toString()),
                Remark: item.remark,
                LeadTimeInDays: item.leadTime,
                DeliveryDate: new Date(item.deliveryDate)?.toISOString()
            };
        });
        const paymentList = paymentData.map((entry) => ({
            PaymentType: entry.type?.toUpperCase(),
            Amount: parseFloat(entry.amount?.toString()),
            RefNo: entry.referenceNumber
        }));

        const payload = {
            RepairProductId: decryptItem(repairWorkItemId as string),
            ...(paymentList.length > 0 && { PaymentDetailsModelList: paymentList })
        };
        try {
            setIsSubmitting(true)
            const response = await createRepairProductOnEditEntry(payload)
            if (response.status == 200) {
                notistack.notifyFromApi(response)
                reset()
                navigate("/repair-product-list", { state: { openSecondReceipt: true } });
            }
            else {
                notistack.notifyFromApi(response);
            }
        } catch (error: any) {
            console.error("Failed to save repair order", error);
            notistack.error(error.message);
        } finally {
            setIsSubmitting(false)
        }
    };

    return (
        <>
            <div className="page-content" style={{
                width: '100%',
                padding: '0 1rem',
                display: 'flex',
                gap: '1rem',
                position: 'relative',
                // top: '75px',
                height: '100vh',
                marginBottom: '100px'
            }}>
                {/* Main Content Container */}
                <div style={{
                    flex: '1',
                    minWidth: '0', // Prevents flex item from overflowing
                    maxWidth: 'calc(100% - 320px)' // Leave space for sidebar
                }}>
                    <h4>Repair Details</h4>
                    <div style={{ width: '100%', maxWidth: '100%' }}>
                        <DataGrid
                            dataSource={productData}
                            keyExpr="id"
                            showRowLines
                            showBorders
                            remoteOperations={false}
                            allowColumnResizing
                            columnAutoWidth
                            wordWrapEnabled
                        >
                            <Summary>
                                <TotalItem
                                // column="sellingPrice" summaryType="sum" displayFormat="Total: {0}" valueFormat="#,##0.00"
                                />
                            </Summary>

                            <Column dataField="id" dataType="number" visible={false} />
                            <Column dataField="styleNo" caption="Style No" />
                            <Column dataField="category" caption="Category" />
                            <Column dataField="diaWt" caption="Dia Wt" dataType="number" format="#,##0.000" />
                            <Column dataField="diaQty" caption="Dia Qty" dataType="number" />
                            <Column dataField="netWt" caption="Net Wt" dataType="number" format="#,##0.000" />
                            <Column dataField="grossWt" caption="Gross Wt" dataType="number" format="#,##0.000" />
                            <Column dataField="kt" caption="Metal KT" />
                            <Column dataField="pcs" caption="Quantity" dataType="number" />
                            <Column dataField="igiNo" caption="IGI No" />
                            <Column dataField="huid" caption="HUID" />

                            <Column
                                dataField="sellingPrice"
                                caption="Selling Price"
                                dataType="number"
                                format="#,##0.00"
                            />
                            <Scrolling
                                mode='standard'
                                useNative={true}
                                scrollByContent={true}
                                scrollByThumb={true}
                            />
                        </DataGrid>
                    </div>

                    {/* <h4 className='mt-3'>Repair Work</h4>
                    <div style={{ width: '90%', maxWidth: '100%' }}>
                        <form onSubmit={handleSubmit(onSubmit)} className="row g-3 align-items-end">
                          
                            <div className="col-md-2">
                                <label className="form-label text-muted small">Reason</label>
                                <select
                                    className="form-select form-select-sm"
                                    {...register("reason", { required: true })}
                                    onChange={handleReasonChange}
                                >
                                    <option value="">Select Reason</option>
                                    {repairReasonList.map((r) => (
                                        <option value={r.text} key={r.value}>
                                            {r.text}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label text-muted small">Qty/Wt</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control form-control-sm"
                                    {...register("qty", { required: true })}
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label text-muted small">Amt</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    className="form-control form-control-sm"
                                    {...register("amount", { required: true })}
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label text-muted small">Remark</label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    {...register("remark")}
                                />
                            </div>

                            <div className="col-md-2">
                                <label className="form-label text-muted small">Lead Duration Days</label>
                                <div className="input-group input-group-sm">
                                    <input
                                        type="number"
                                        className="form-control"
                                        {...register("leadTime")}
                                        value={leadTime ?? ""}
                                        disabled
                                    />
                                    <span className="input-group-text bg-light text-muted small">Days</span>
                                </div>
                            </div>

                            <div className="col-md-2">
                                <label className="form-label text-muted small">Delivery Date</label>
                                <div className="d-flex gap-2">
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        {...register("deliveryDate")}
                                        value={deliveryDate}
                                        disabled
                                    />
                                    <Button type="submit" size="sm" className="submit-btn">
                                        {editIndex !== null ? "Update" : "Add"}
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </div> */}

                    <div className='d-flex gap-2 my-3 flex-wrap'>
                        <Button
                            variant={`outline-primary ${customer?.length > 0 ? 'bg-success text-white border-success' : ''}`}
                            size="sm"
                            onClick={handleCustomerClickModal}
                        >
                            <i className="bx bx-user me-1"></i>
                            Customer
                        </Button>
                        <Button
                            variant={`outline-primary ${salesPersonId ? 'bg-success text-white border-success' : ''}`}
                            size="sm"
                            onClick={handleSalesPersonClick}
                        >
                            <i className="bx bx-user-check me-1"></i>
                            Sales Person
                        </Button>
                        <Button
                            variant={`outline-primary ${paymentData.length > 0 ? 'bg-success text-white border-success' : ''}`}
                            size="sm"
                            onClick={paymentData.length > 0 ? openEditPaymentModal : openAddPaymentModal}
                        >
                            <i className="bx bx-credit-card me-1"></i>
                            Payment
                        </Button>
                    </div>

                    <div className='d-flex gap-2 my-3'>
                        {/* <form action="">
                            Image
                            <input type="file" />
                        </form> */}
                    </div>

                    <div style={{ width: '100%', maxWidth: '100%' }}>
                        <DataGrid dataSource={data} keyExpr="deliveryDate" showBorders columnAutoWidth={true}>
                            <Column dataField="repairWork" caption="Repair Reason" />
                            <Column dataField="qtyOrWt" caption="Qty/Gm" />
                            <Column dataField="repairAmount" caption="Est Amt" />
                            <Column dataField="remark" caption="Store Remark" />
                            <Column dataField="leadTimeInDays" caption="Lead Duration Days" width={150} />
                            <Column
                                dataField="deliveryDate"
                                caption="Delivery Date"
                                dataType="date"
                                format="dd/MM/yyyy"
                            />
                            <Scrolling
                                mode='standard'
                                useNative={true}
                                scrollByContent={true}
                                scrollByThumb={true}
                            />
                        </DataGrid>
                    </div>
                </div>

                {/* Payment Details Sidebar - Fixed Position */}
                <div style={{
                    width: '300px',
                    flexShrink: 0,
                    position: 'sticky',
                    top: '1rem',
                    alignSelf: 'flex-start',
                    maxHeight: 'calc(100vh - 2rem)',
                    overflowY: 'auto'
                }}>
                    <div className="card " style={{ marginTop: "2rem" }}>
                        <div className="card-header text-center bg-light">
                            <h6 className="mb-0">Payment Details</h6>
                        </div>
                        <div className="card-body p-0">
                            <table className="table table-sm mb-0">
                                <tbody>
                                    <tr>
                                        <td className="ps-3">SGST (2.5%)</td>
                                        <td className="text-end pe-3">₹ {totalSGST?.toFixed(2)}</td>
                                    </tr>
                                    <tr>
                                        <td className="ps-3">CGST (2.5%)</td>
                                        <td className="text-end pe-3">₹ {totalCGST?.toFixed(2)}</td>
                                    </tr>
                                    <tr className="table-info">
                                        <td className="ps-3"><strong>Total Amount</strong></td>
                                        <td className="text-end pe-3"><strong>₹ {totalAmount?.toFixed(2)}</strong></td>
                                    </tr>
                                </tbody>
                            </table>

                            <table className="table table-bordered table-sm mt-3">
                                <thead className="table-light">
                                    <tr>
                                        <th colSpan={2} className="text-center">
                                            Payment Details
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paymentData.map((payment) => (
                                        <tr key={payment.id}>
                                            <td>{payment.type}</td>
                                            <td className="text-end">₹ {Number(payment.amount).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                    <tr className="table-info">
                                        <td><strong>Total Paid</strong></td>
                                        <td className="text-end">
                                            <strong>₹ {paymentData.reduce((sum, payment) => {
                                                return sum + Number(payment.amount || 0);
                                            }, 0).toFixed(2)}</strong>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2} className="text-end pe-3 pt-3">
                                            <button className="btn add-btn me-2" onClick={handleCancel}>Cancel</button>
                                            <button className="btn submit-btn" disabled={isSubmitting} onClick={handleSave}>Accept</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* customer modal */}
            <Modal
                size='lg'
                show={showCustomerModal} onHide={() => setShowCustomerModal(false)}
                backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Customer Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <CustomerDataModal customerData={customer} />
                </Modal.Body>
            </Modal>

            {/* Sales person modal */}
            <SalesPersonModal
                show={showSalesPersonModal}
                onHide={() => setShowSalesPersonModal(false)}
                onSelect={handleSalesPersonSelect}
                selectedSalesPersonId={salesPersonId}
            />

            {/* Payment modal */}
            <PaymentModal
                show={showPaymentModal}
                onHide={() => setShowPaymentModal(false)}
                handelPaymentData={handlePaymentData}
                initialPaymentData={editingPaymentData}
                maxAllowedAmount={totalAmount}
            />
        </>
    );
};

export default RepairProductsDetails1;
